import { location } from './env';
import { makeRandomString } from './makeRandomString';

export const KEY_RANDOM_PART_LENGTH = 32;

type KeyType =
  | 'item'
  | 'image'
  | 'inventory'
  | 'room'
  | 'text-message'
  | 'notification'
  | 'video'
  | 'email-message'
  | 'email-thread'
  | 'email-attachment'
  | 'note'
  | 'task'
  | 'company'
  | 'alternate-contact'
  | 'group'
  | 'smart-consult-background-image'
  | 'generated-document-settings'
  | 'document-template'
  | 'room-option'
  | 'vehicle-shipment'
  | 'playbook';

export const generateKey = ({ type }: { type: KeyType }) => {
  const length = KEY_RANDOM_PART_LENGTH;
  const string = `${location}${makeRandomString({ length })}`;

  switch (type) {
    case 'item':
      return `tg${string}`;
    case 'image':
      return `img${string}`;
    case 'inventory':
      return `inv${string}`;
    case 'room':
      return `rm${string}`;
    case 'text-message':
      return `tmsg${string}`;
    case 'notification':
      return `nt${string}`;
    case 'video':
      return `vid${string}`;
    case 'email-message':
      return `emmsg${string}`;
    case 'email-thread':
      return `emtd${string}`;
    case 'email-attachment':
      return `ematc${string}`;
    case 'note':
      return `nt${string}`;
    case 'task':
      return `tsk${string}`;
    case 'company':
      return `co${string}`;
    case 'alternate-contact':
      return `altcont${string}`;
    case 'group':
      return `grp${string}`;
    case 'generated-document-settings':
      return `gdcst${string}`;
    case 'document-template':
      return `dct${string}`;
    case 'room-option':
      return `rmopt${string}`;
    case 'vehicle-shipment':
      return `vship${string}`;
    case 'playbook':
      return `pb${string}`;

    default:
      throw new Error('Unrecognized "type" parameter provided to generateKey()');
  }
};
